import { Logo } from "@/components/brand";

/**
 * The sign-in showcase's one moving thing: a member card, floating slowly, with
 * a single sheen passing over it. Everything on it is illustrative — no real
 * member is shown. Decorative, so the whole card is hidden from assistive
 * technology, and the global reduced-motion rule stops both animations.
 */
export function MemberCard() {
  return (
    <div aria-hidden className="relative w-full max-w-xs sm:max-w-sm">
      {/* A second card behind: this is a system of records, not one card. */}
      <div className="bg-brand-200/70 dark:bg-brand-600/40 absolute inset-x-4 -top-3 h-full rounded-2xl" />

      <div className="animate-float-card bg-brand-700 relative isolate aspect-[1.586] overflow-hidden rounded-2xl p-5 text-white shadow-[0_24px_48px_-16px_rgba(15,33,65,0.55)] sm:p-6">
        {/* Guilloche-like arcs in the brand navy family, never louder than the text. */}
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(90%_120%_at_100%_110%,var(--color-brand-500)_0%,transparent_60%),radial-gradient(60%_80%_at_-10%_-10%,var(--color-brand-600)_0%,transparent_60%)]" />
        <div className="animate-sheen absolute inset-y-0 -left-1/4 w-1/3 bg-gradient-to-r from-transparent via-white/25 to-transparent" />

        <div className="flex items-start justify-between">
          <Logo tone="light" className="w-24 sm:w-28" />
          {/* The chip. */}
          <div className="grid h-7 w-9 grid-cols-3 gap-px overflow-hidden rounded-md bg-gradient-to-br from-[#f3e2a9] to-[#c9a44a] p-1 sm:h-8 sm:w-10">
            {Array.from({ length: 6 }, (_, index) => (
              <span key={index} className="rounded-[2px] bg-[#a98530]/50" />
            ))}
          </div>
        </div>

        <p className="mt-6 font-mono text-lg tracking-[0.18em] text-white/90 sm:mt-8 sm:text-xl">
          4271 0000 0001
        </p>

        <div className="text-footnote sm:text-footnote mt-auto flex items-end justify-between pt-5 leading-tight">
          <div>
            <p className="text-white/60">Member</p>
            <p className="text-callout mt-0.5 font-medium tracking-wide">Juan dela Cruz</p>
          </div>
          <div className="text-right">
            <p className="text-white/60">Valid until</p>
            <p className="text-callout mt-0.5 font-mono">09/2027</p>
          </div>
        </div>
      </div>
    </div>
  );
}
